// extracted by mini-css-extract-plugin
module.exports = {"landing":"landing_landing__3Kzvq","tittle":"landing_tittle__xJjhc","button":"landing_button__TCy7j"};